import ApiService from './ApiService.js';  
const uuidv1 = require('uuid/v1');
const querystring = require('querystring') 
var RolesService = { 

        findAll($data) { 
            return new Promise(function(resolve,reject) { 
            var $options= {}; 
            $options.url ='roles' 
            $options.method='get' 
            if($data) { 
                $options.url='roles?'+ querystring.stringify($data) 
            } 
            ApiService.request($options) 
                .then(response => {  
                    resolve(response.data.data) 
                }).catch(error=> { 
                    reject(error);
                }) 
            });
        }, 
        findOne($data) { 
            return new Promise(function(resolve,reject) { 
            var $options= {}; 
            $options.url ='roles' 
            $options.method='get' 
            if($data) { 
                $options.url='roles/'+$data.id 
            } 
            ApiService.request($options) 
                .then(response => {  
                    resolve(response.data.data) 
                }).catch(error=> { 
                    reject(error);
                }) 
            });
        }, 
        
        create: function ($data) {
           return new Promise(function (resolve, reject) {
               var $options = {};
               $options.data={};
               $options.data.name= $data.name;
               $options.data.created= $data.created;
               $options.data.modified= $data.modified;
               $options.data.company_id = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE)).data.User.company_id
               $options.data.active= $data.active;
               $options.url = "roles"
               $options.method="post"
               console.log($options)
               ApiService.request($options)
                   .then(response => {
                       resolve(response)
                   }).catch(error => {
                       reject(error)
                   });
               });
       },
       save: function ($data) {
           return new Promise(function (resolve, reject) {
               var $options = {};
               $options.data={};
               $options.data.name= $data.name;
               $options.data.created= $data.created;
               $options.data.modified= $data.modified;
               $options.data.company_id = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE)).data.User.company_id
               $options.data.active= $data.active;
               $options.url = "roles/"+$data.id;
               $options.method="post"
               console.log($options)
               ApiService.request($options)
                   .then(response => {
                       resolve(response)
                   }).catch(error => {
                       reject(error)
                   });
               });
       },      
       getRoleForMyId () {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.url = 'myRole'
            $options.method = 'get'          
            ApiService.request($options)
                .then(response => {
                    resolve(response.data.data)
                }).catch(error => {
                    reject(error);
                })
        });
    }
}; 
export default RolesService;